import React, { useState } from 'react';
import { DollarSign, ExternalLink, Info } from 'lucide-react';

const Payroll = ({ currentUser }) => {
  // ADP link for AG&WESTERN Rail employees
  const adpLink = 'https://signin.online.adp.com/signin/v1/?APPID=HomepagePortal&productId=80e309c3-7078-bae1-e053-3505430b5495&returnURL=https://portal.adp.com/public/index.htm&callingAppId=HomepagePortal';

  return (
    <div style={{ padding: '2rem' }}>
      <div style={{ 
        maxWidth: '900px', 
        margin: '0 auto',
        background: 'white',
        borderRadius: '12px',
        padding: '2rem',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        {/* Header */}
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: '0.75rem',
          marginBottom: '1.5rem',
          paddingBottom: '1rem',
          borderBottom: '2px solid #f0f0f0'
        }}>
          <DollarSign size={28} style={{ color: '#000' }} />
          <h2 style={{ margin: 0, fontSize: '1.75rem', fontWeight: '700', color: '#000' }}>
            Payroll & Paychecks
          </h2>
        </div>

        {/* Info Box */}
        <div style={{
          background: '#f8f9fa',
          border: '1px solid #e0e0e0',
          borderRadius: '8px',
          padding: '1.5rem',
          marginBottom: '2rem',
          display: 'flex',
          gap: '1rem'
        }}>
          <Info size={24} style={{ color: '#666', flexShrink: 0 }} />
          <div>
            <h3 style={{ margin: '0 0 0.5rem 0', fontSize: '1.1rem', fontWeight: '600' }}>
              Access Your Payroll Information
            </h3>
            <p style={{ margin: 0, color: '#666', lineHeight: '1.6' }}>
              AG&WESTERN Rail uses ADP for payroll management. Click the link below to access 
              your paychecks, tax documents, direct deposit information, and more.
            </p>
          </div>
        </div>

        {/* ADP Access Section */}
        <div style={{
          background: '#fff',
          border: '2px solid #000',
          borderRadius: '8px',
          padding: '2rem',
          textAlign: 'center'
        }}>
          <DollarSign size={48} style={{ color: '#000', marginBottom: '1rem' }} />
          <h3 style={{ 
            fontSize: '1.5rem', 
            fontWeight: '700', 
            marginBottom: '1rem',
            color: '#000'
          }}>
            ADP Payroll Portal
          </h3>
          <p style={{ 
            color: '#666', 
            marginBottom: '1.5rem',
            fontSize: '1rem'
          }}>
            View your paychecks, pay stubs, W-2 forms, and manage direct deposit
          </p>

          {adpLink ? (
            <a
              href={adpLink}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.5rem',
                background: '#000',
                color: '#fff',
                padding: '0.875rem 2rem',
                borderRadius: '6px',
                textDecoration: 'none',
                fontSize: '1rem',
                fontWeight: '600',
                transition: 'all 0.2s',
                cursor: 'pointer',
                border: 'none'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.background = '#333';
                e.currentTarget.style.transform = 'translateY(-2px)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.background = '#000';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              Open ADP Portal
              <ExternalLink size={18} />
            </a>
          ) : (
            <div style={{
              background: '#fff3cd',
              border: '1px solid #ffc107',
              borderRadius: '6px',
              padding: '1rem',
              color: '#856404'
            }}>
              <strong>Coming Soon</strong>
              <p style={{ margin: '0.5rem 0 0 0', fontSize: '0.9rem' }}>
                The ADP payroll link will be available here shortly. Check back soon!
              </p>
            </div>
          )}
        </div>

        {/* Instructions */}
        <div style={{ marginTop: '2rem' }}>
          <h4 style={{ 
            fontSize: '1.1rem', 
            fontWeight: '600', 
            marginBottom: '1rem',
            color: '#000'
          }}>
            First Time Logging In?
          </h4>
          <ol style={{ 
            color: '#666', 
            lineHeight: '1.8',
            paddingLeft: '1.5rem',
            margin: 0
          }}>
            <li>Click the "Open ADP Portal" button above</li>
            <li>Use your AG&WESTERN Rail email address: <strong>{currentUser?.email}</strong></li>
            <li>If you haven't set up your ADP account yet, click "First Time User" to register</li>
            <li>Follow the prompts to create your secure password</li>
            <li>Once logged in, you can view all your payroll information</li>
          </ol>
        </div>

        {/* Support */}
        <div style={{
          marginTop: '2rem',
          padding: '1rem',
          background: '#f8f9fa',
          borderRadius: '6px'
        }}>
          <p style={{ margin: 0, fontSize: '0.9rem', color: '#666' }}>
            <strong>Need Help?</strong> Contact HR at{' '}
            <a href="mailto:JenniferMajor.CHRO@agwesternrail.com" style={{ color: '#000' }}>
              JenniferMajor.CHRO@agwesternrail.com
            </a>
            {' '}or{' '}
            <a href="mailto:Aaron.Gregory@agwesternrail.com" style={{ color: '#000' }}>
              Aaron.Gregory@agwesternrail.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Payroll;
